export default "__VITE_ASSET__DktScKEH__"